import { render, staticRenderFns } from "./TaskDetailHistoryBlock.vue?vue&type=template&id=2630f6af&scoped=true&lang=pug&"
import script from "./TaskDetailHistoryBlock.vue?vue&type=script&lang=js&"
export * from "./TaskDetailHistoryBlock.vue?vue&type=script&lang=js&"
import style0 from "./TaskDetailHistoryBlock.vue?vue&type=style&index=0&id=2630f6af&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2630f6af",
  null
  
)

export default component.exports